import { render, staticRenderFns } from "./ReviewBox.vue?vue&type=template&id=86c1ea6e&scoped=true&"
import script from "./ReviewBox.vue?vue&type=script&lang=js&"
export * from "./ReviewBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c1ea6e",
  null
  
)

export default component.exports